import * as React from 'react'

export interface ISubStatusTripProps {
  displayText: string
}

const SubStatusTrip = (props: ISubStatusTripProps) => {
  const { displayText } = props

  return (
    <div className='center py05 bold'>
      <p className='font-dark-grey uppercase h5' style={{ marginTop: '5px', marginBottom: '5px' }}>
        {displayText}
      </p>
    </div>
  )
}

export default SubStatusTrip



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/SubStatusTrip.tsx